import React from 'react';
import { arrayOf, object, bool } from 'prop-types';
import styled from 'styled-components';

import Image from './images/ajuda.svg';
import QuestionsList from './question/QuestionsList';
import OrangeButton from './../OrangeButton';
import { isNotWebview } from '../../libs/browser/browser';

const QuestionsSection = styled.section`
  background-color: #ffffff;
  text-align: center;
  margin-top: 110px;
  @media (min-width: 1000px) {
    margin-top: 120px;
    display: flex;
    justify-content: center;
  }
`;

const Wrapper = styled.div`
  padding-bottom: 40px;
  @media (min-width: 1000px) {
    width: 970px;
    padding-bottom: 64px;
  }
`;

const HelpImage = styled.img`
  width: 120px;
  height: 92px;
  object-fit: contain;
  margin-top: -64px;
  @media (min-width: 1000px) {
    width: 160px;
    height: 118px;
    margin-top: -85px;
  }
`;

const Title = styled.span`
  font-size: 24px;
  line-height: 1.33;
  color: #4a4a4a;
  display: block;
`;

const SubTitle = styled.span`
  font-size: 16px;
  line-height: 2;
  color: #999999;
`;

const TitleDiv = styled.div`
  padding: 32px 0 0 0;
  @media (min-width: 1000px) {
    padding: 28px 0 0 0;
  }
`;

const QuestionsBox = ({ questions, hideKnowMoreButton }) => (
  <QuestionsSection data-e2e="questions-section" id="questions">
    <Wrapper>
      <HelpImage src={Image} alt="ajuda" />
      <TitleDiv>
        <Title>Ficou com alguma dúvida?</Title>
        <SubTitle>Veja as perguntas frequentes</SubTitle>
      </TitleDiv>
      <QuestionsList questions={questions} />
      {isNotWebview && !hideKnowMoreButton && (
        <OrangeButton
          href="https://ajuda.olx.com.br/s/article/como-funcionam-planos-profissionais"
          target="_blank"
        >
          Quero saber mais
        </OrangeButton>
      )}
    </Wrapper>
  </QuestionsSection>
);

QuestionsBox.propTypes = {
  questions: arrayOf(object).isRequired,
  hideKnowMoreButton: bool,
};

QuestionsBox.defaultProps = {
  hideKnowMoreButton: false,
};

export default QuestionsBox;
